import { Box, Card, CardContent } from '@mui/material';
import { useSearchParams } from 'react-router';
import { PageHeader } from '../../components/states';
import { ContactCard } from '../shop/subscription/ContactCard';
import { SupportChat } from './SupportChat';

/** Chat with PackBytes support, with the other ways to reach us beside it. */
export function SupportPage() {
  // ?message= starts the composer with that text ("Hi, I want the WhatsApp feature").
  const [params] = useSearchParams();
  return (
    <>
      <PageHeader
        title="Support"
        subtitle="Message the PackBytes team. Replies appear here and in the Support menu badge."
      />
      <Box
        sx={{
          display: 'grid',
          gap: 2.5,
          gridTemplateColumns: { xs: 'minmax(0,1fr)', lg: 'minmax(0,2fr) minmax(0,1fr)' },
          alignItems: 'start',
        }}
      >
        <Card>
          <CardContent sx={{ p: { xs: 1.5, sm: 2.5 } }}>
            <SupportChat
              height="min(640px, calc(100dvh - 260px))"
              draft={params.get('message')?.slice(0, 500) ?? ''}
            />
          </CardContent>
        </Card>
        <ContactCard />
      </Box>
    </>
  );
}
